import { Box, Stack } from "@mui/material";
import Image from "next/image";
import seatIconImg from "public/images/seat-icon.png";
import { SSButton } from "src/components/base/components/SSButton";
import { SSText } from "src/components/base/components/SSText";
import { useSSTheme } from "../hooks/useSSTheme";
import { useCssMediaQuery } from "src/components/base/hooks/useCssMediaQuery";
import React from "react";
import { useTicketmaster } from "../hooks/useTicketmaster";
import { routes } from "src/shared/routes";
import { useGlobalStore } from "../hooks/useGlobalStore";
import { useRouterExt } from "../hooks/useRouterExt";
import { useTeamConfig } from "./TeamConfigProvider";
import { useSeatGeek } from "../hooks/useSeatGeek";
import { constants } from "src/shared/constants";
import { useTicketsdotcom } from "../hooks/useTicketsdotcom";

export function SWAFPrompt(props: {
  renderActionButton?: () => React.ReactNode;
}) {
  const router = useRouterExt();
  const theme = useSSTheme();
  const { sm: smUp } = useCssMediaQuery("up");
  const { connectTicketmaster } = useTicketmaster();
  const { user, swafConfig } = useGlobalStore();
  const { VENDOR, TEAM_GLOBAL_SETTINGS } = useTeamConfig();
  const { connectSeatGeek } = useSeatGeek();
  const urlCode = router.query.urlCode as string;
  const { connectTicketsdotcom } = useTicketsdotcom();

  async function handleClick() {
    if (user) {
      return await router.pushSchema({
        pathname: routes.my_group,
        query: {
          ...(urlCode && { urlCode }),
        },
      });
    }

    const state = {
      authOrigin: "swafPromptGetStart",
      redirectRoute: {
        pathname: routes.my_group,
        query: {
          ...(urlCode && { urlCode }),
        },
      },
    };

    if (VENDOR === constants.vendorUUIDs.seatgeek) {
      return await connectSeatGeek(state);
    }

    if (VENDOR === constants.vendorUUIDs.ticketsdotcom) {
      return await connectTicketsdotcom(state);
    }

    connectTicketmaster({ state });
  }

  if (TEAM_GLOBAL_SETTINGS?.DISABLE_SIT_WITH_FRIENDS) return null;

  return (
    <Box
      bgcolor={"#DEDEDE"}
      borderRadius={2}
      px={6}
      py={4}
      border={`1px solid ${theme.colors.border}`}
    >
      <Stack alignItems={"center"}>
        <Image alt="seat icon" src={seatIconImg.src} width={96} height={96} />
      </Stack>

      <Stack alignItems={"center"} textAlign={"center"}>
        <Box>
          <SSText variant="h5" fontWeight={700} lineHeight={1.2}>
            Want to enjoy games with your friends?
          </SSText>
        </Box>

        <Box mt={1}>
          <SSText variant="body" lineHeight={1.2}>
            Your friends will sit next to you when you create a group.
          </SSText>
        </Box>

        <Box mt={2}>
          {props?.renderActionButton?.() || (
            <SSButton
              disabled={swafConfig?.isSwafDisabled}
              variant="contained"
              size="large"
              colorScheme={theme.colors.teamPrimary}
              disableElevation
              sx={{ minWidth: smUp ? "200px" : "130px" }}
              onClick={handleClick}
            >
              Get Started
            </SSButton>
          )}
        </Box>
      </Stack>
    </Box>
  );
}
